import { instanceWithRetry } from "actions/axiosInstance";
import { generateQueryString } from "utils/query";
const CONFIG_URL = "/config/environment_config";
export const SUPPORT_USER_LIST_URL = "payadmin/users";
export const APPLICATION_ANNOUNCEMENTS_URL = "/application-announcements";

export const fetchSupportUsers = async (params) => {
  const response = await instanceWithRetry.get(SUPPORT_USER_LIST_URL, {
    params,
  });
  return response.data;
};

export const exportSupportUsers = async (params) =>
  instanceWithRetry.get(SUPPORT_USER_LIST_URL, {
    params: { ...params, export: 1 },
    responseType: "blob",
  });

export const getConfigurationDetails = async (payload) => {
  try {
    const { currentPage, per_page = "", mutate = "" } = payload;
    const url = `${CONFIG_URL}${generateQueryString({ page: currentPage, per_page, mutate })}`;
    const result = await instanceWithRetry.get(url);
    return result.data;
  } catch (error) {
    return error;
  }
};

export const searchEnvironmentConfigurations = async (q = "") => {
  const query = String(q || "").trim();
  if (!query) {
    return {
      query: "",
      count: 0,
      results: [],
      has_more: false,
    };
  }

  const response = await instanceWithRetry.get(`${CONFIG_URL}/search`, {
    params: { q: query },
  });
  const data = response?.data;

  if (Array.isArray(data)) {
    return {
      query,
      count: data.length,
      results: data,
      has_more: false,
    };
  }

  return {
    query: data?.query ?? query,
    count: Number(data?.count || 0),
    results: Array.isArray(data?.results) ? data.results : [],
    has_more: Boolean(data?.has_more),
  };
};

export const getConfigVariables = () => (dispatch) => {
  getConfigurationDetails({ page: 1, per_page: 1000 }).then((data) => {
    if (data && data?.result?.length > 0) {
      dispatch({
        type: "SET_CONFIG_VARIABLES",
        payload: data.result,
      });
    }
  });
};

export const saveConfiguration = async (payload) => {
  try {
    const result = await instanceWithRetry.post(
      `${CONFIG_URL}?mutate=1`,
      payload
    );
    return result?.data;
  } catch (error) {
    return error;
  }
};

export const deleteConfiguration = async (payload) => {
  try {
    const { name } = payload;
    const url = `${CONFIG_URL}?name=${name}&mutate=1`;
    const result = await instanceWithRetry.delete(url);
    return result.data;
  } catch (error) {
    return error;
  }
};

export const getApplicationAnnouncements = async (mutate = 0) => {
  const response = await instanceWithRetry.get(
    `${APPLICATION_ANNOUNCEMENTS_URL}${mutate ? "?mutate=1" : ""}`
  );
  return response.data?.result ?? [];
};

export const getActiveApplicationAnnouncement = async (mutate = 0) => {
  const response = await instanceWithRetry.get(
    `${APPLICATION_ANNOUNCEMENTS_URL}/active${mutate ? "?mutate=1" : ""}`
  );
  return response.data?.result ?? null;
};

export const createApplicationAnnouncement = async (payload) => {
  const response = await instanceWithRetry.post(
    `${APPLICATION_ANNOUNCEMENTS_URL}?mutate=1`,
    payload
  );
  return response.data;
};

export const updateApplicationAnnouncement = async (id, payload) => {
  const response = await instanceWithRetry.put(
    `${APPLICATION_ANNOUNCEMENTS_URL}/${id}?mutate=1`,
    payload
  );
  return response.data;
};

export const deleteApplicationAnnouncement = async (id) => {
  const response = await instanceWithRetry.delete(
    `${APPLICATION_ANNOUNCEMENTS_URL}/${id}?mutate=1`
  );
  return response.data;
};

// Client Configuration API functions
export const getClientConfiguration = async () => {
  try {
    const result = await instanceWithRetry.get(
      "/client/config/setting?description=customer setting"
    );
    return result.data;
  } catch (error) {
    return error;
  }
};

export const updateClientConfiguration = async (flagName, value) => {
  try {
    const payload = {
      config_setting: [
        {
          name: flagName,
          value: value.toString(),
          type: "BOOLEAN",
          description: "customer setting",
        },
      ],
    };

    const result = await instanceWithRetry.put(
      "/client/config/setting?mutate=1",
      JSON.stringify(payload)
    );
    return result.data;
  } catch (error) {
    return error;
  }
};

/* 
AI Control
*/

const apiVersion = "v1.0";

export const getAITokenPlans = async () => {
  const result = await instanceWithRetry.get(`/${apiVersion}/ai/token/plans`);

  return result.data?.result || [];
};

export const postAITokenPlan = async (payload) => {
  const result = await instanceWithRetry.post(
    `/${apiVersion}/ai/token/plans?mutate=1`,
    payload
  );
  return result.data?.result;
};

export const getAIClientTokenAssignments = async () => {
  const result = await instanceWithRetry.get(
    `/${apiVersion}/ai/client/token/assignments`
  );

  return result.data?.result || [];
};

export const postAIClientTokenAssignments = async (payload) => {
  const result = await instanceWithRetry.post(
    `/${apiVersion}/ai/client/token/assignments?mutate=1`,
    payload
  );

  return result.data;
};

export const putAIClientTokenAssignments = async (payload) => {
  const result = await instanceWithRetry.put(
    `/${apiVersion}/ai/client/token/assignments/${payload.id}?mutate=1`,
    payload
  );

  return result.data;
};
